import {
    Button,
    Container,
    Form,
    FormGroup,
    Input,
    Message,
    Segment,
    SegmentContent,
    SegmentHeader,
    Toggle,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import Navigation from './components/Navigation';

const CustomerSettingView = () => {
    const { auth, settings, retain_after_period, retain_after_employment } =
        usePage().props;
    const { data, setData, patch, processing } = useForm(settings || {});

    const handleSubmit = () => {
        patch(
            `/customers/${auth?.user?.selected_customer_id}/services/no-risk/settings/customers`,
            {
                preserveScroll: true,
                preserveState: false,
            }
        );
    };

    return (
        <Container fluid>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='Klant instellingen'
                    subheader='Hier kunt u specifieke instellingen aanpassen voor de gehele klant.'
                />

                <SegmentContent>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Toggle
                                label='Interne meldingen inschakelen'
                                disabled={
                                    !auth?.permissions?.includes(
                                        'update no-risk support settings'
                                    )
                                }
                                checked={data?.notifications_enabled || false}
                                onChange={checked =>
                                    setData(
                                        'notifications_enabled',
                                        checked ? 1 : 0
                                    )
                                }
                            />

                            {auth?.permissions?.includes(
                                'update no-risk retention periods'
                            ) && (
                                <>
                                    <Message
                                        variant='info'
                                        content={`If u de velden leeg laat, worden de standaardwaarden van ${retain_after_period}/${retain_after_employment} maanden gebruikt.`}
                                    />

                                    <Input
                                        type='number'
                                        label='Bewaren na periode'
                                        description='Aantal maanden om de werknemer te behouden nadat de no-riskperiode is verstreken.'
                                        value={data?.retain_after_period || ''}
                                        onChange={event =>
                                            setData(
                                                'retain_after_period',
                                                event.target.value
                                            )
                                        }
                                    />

                                    <Input
                                        type='number'
                                        label='Bewaren na dienstverband'
                                        description='Aantal maanden om een werknemer te behouden nadat het dienstverband is beëindigd.'
                                        value={
                                            data?.retain_after_employment || ''
                                        }
                                        onChange={event =>
                                            setData(
                                                'retain_after_employment',
                                                event.target.value
                                            )
                                        }
                                    />
                                </>
                            )}

                            <div className='flex justify-end'>
                                <Button
                                    variant='primary'
                                    type='submit'
                                    loading={processing}
                                >
                                    Opslaan
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </SegmentContent>
            </Segment>
        </Container>
    );
};

export default CustomerSettingView;
